import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';

import { AuthGuard } from '@core/auth/auth.guard';
import { CreateAccountComponent } from '@feature/create-account/create-account-page/create-account.component';
import { ConnectivityComponent } from '@feature/diagnostics/connectivity/connectivity.component';
import { Error404Component } from '@feature/home/error404/error404.component';
import { LegalPageComponent } from '@shared/components/legal-page/legal-page.component';
import { NewSiteStepOneComponent } from '@shared/components/new-site-step-one/new-site-step-one.component';
import { RoleEnum } from '@shared/constants/role.enums';

const routes: Routes = [
  {
    path: 'auth',
    loadChildren: () => import('./feature/auth/auth.module').then(m => m.AuthModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'admin',
    canActivate: [AuthGuard],
    data: {
      roles: [RoleEnum.Admin, RoleEnum.SuperAdmin, RoleEnum.ReadAdmin, RoleEnum.FinanceAdmin],
    },
    loadChildren: () => import('./feature/admin/admin.module').then(m => m.AdminModule),
  },
  {
    path: 'account',
    canActivate: [AuthGuard],
    data: { roles: [RoleEnum.Landowner] },
    loadChildren: async () => (await import('./feature/account/account.module')).AccountModule,
  },
  {
    path: 'site',
    canActivate: [AuthGuard],
    data: { roles: [RoleEnum.Landowner] },
    loadChildren: () => import('./feature/site/site.module').then(m => m.SiteModule),
  },
  {
    path: 'legal/:pageType',
    component: LegalPageComponent,
  },
  {
    path: 'connectivity',
    component: ConnectivityComponent,
  },
  {
    path: 'create-account',
    component: CreateAccountComponent,
  },
  {
    path: 'start-site',
    component: NewSiteStepOneComponent,
  },
  {
    path: '',
    component: NewSiteStepOneComponent,
  },
  { path: '**', component: Error404Component },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      preloadingStrategy: PreloadAllModules,
      scrollPositionRestoration: 'enabled',
      // This instructs the Angular router to compute (re-compute) the URL after a canceled navigation, ensuring that the browser's URL bar reflects the correct state of your application.
      // This might become the default behavior in the future
      // See: https://github.com/angular/angular/issues/13586#issuecomment-898704702
      canceledNavigationResolution: 'computed',
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {
}
